<template>
  <!-- content -->
  <!-- 특징 -->
  <div class="osResContent">  
    <!-- 선택 영역  -->
    <div class="widL txtC">
      <!-- ABC선택 -->
      <div class="marTX">
        <p><strong class="padSM disIb fntP bold" style="background-color:#000; color:#fff; width:8.3em; border-radius:2em;line-height:1">ABC 선택</strong></p>
        <div class="marTM">
          <select class="form-control" id="mainOperatorMobile" v-model="selectAbc" @change="$emit('abc',selectAbc); selectDay = selectTime = ''">
            <option value="" selected>ABC 선택하기</option>
            <option v-for="(value, ids) in abcList" :value="ids" :key="ids">{{value}}</option>
          </select>
        </div>
      </div>
      <!-- /// ABC선택 -->

      <!-- 날짜선택 -->
      <div class="marTXX">
        <p><strong class="padSM disIb fntP bold" style="background-color:#000; color:#fff; width:8.3em; border-radius:2em;line-height:1">날짜 선택</strong></p>
        <div class="marTM">
          <select class="form-control" id="mainOperatorMobile" v-model="selectDay" @change="$emit('day', selectDay); selectTime = ''">
            <option value="">날짜 선택하기</option>
            <option v-for="(value, ids) in dayList" :value="ids" :key="ids" v-show="reserve.abc != ''">{{value}}</option>
          </select>
        </div>
      </div>
      <!-- /// 날짜선택 -->

      <!-- 시간대 선택 -->
      <div class="marTXX">
        <p><strong class="padSM disIb fntP bold" style="background-color:#000; color:#fff; width:8.3em; border-radius:2em;line-height:1">시간대 선택</strong></p>
        <div class="marTM">
          <select class="form-control" id="mainOperatorMobile" v-model="selectTime" @change="$emit('time', selectTime)">
            <option value="">시간대 선택하기</option>
            <option v-for="(value, ids) in timeList" :value="ids" :key="ids" v-show="reserve.day != ''" v-bind:disabled="isReserved(ids)" >{{isReservedLabel(ids)}} {{value}}</option>
          </select>
        </div>
      </div>
      <!-- /// 시간대 선택 -->

      <!-- 원하는 메이크업 룩 선택 -->
      <div class="marTXX">
        <p><strong class="padSM disIb fntP bold" style="background-color:#000; color:#fff; width:10.3em; border-radius:2em;line-height:1">원하는 메이크업 룩</strong></p>
        <div class="marTM">
          <form>
            <label class="amw-radio-wrap radio-label" v-for="item in makeupList" :key="item.value">
              <img :src="item.img" :alt="item.alt" style="max-width: 420px;" class="icoXXL">
              <div class="marTM marBML" style="position: relative;">
                <input type="radio" name="imges" class="amw-global-radio" v-model="selectStyle" :value="item.value" @change="$emit('style', selectStyle)">
                <span class="amw-radio-overlay"></span>
                <p class="marTS fntP" style="color: #2c2c2c;">{{item.desc}}<br>
                  <strong style="font-weight: bold;">{{item.alt}}</strong></p>
              </div>
            </label>
          </form>
        </div>
      </div>
      <!-- /// 원하는 메이크업 룩 선택 -->

    </div>
      <!-- ///선택 영역  -->
  </div>

  <!-- //content -->
</template>

<script>

export default {
  name: "artistryMakeoverContent",
  props: ['reserve', 'abcList', 'dayList', 'timeList', 'makeupList', 'reservedTime'],
  data() {
    return {
      selectAbc: '',
      selectDay: '',
      selectTime: '',
      selectStyle: '',
    }
  },
  methods: {
    isReserved(time) { 
      return this.reservedTime.findIndex(y => y == time) > -1 
    },
    isReservedLabel(time) { 
      return this.reservedTime.findIndex(y => y == time) > -1 ? "(예약불가)"  : ''
    },
    init() {
      this.selectAbc = ''
      this.selectDay = ''
      this.selectTime = ''
      this.selectStyle = ''
    }
  },
  mounted() {
    this.init()
  },
};
</script>
<style scoped>
@import "../css/font_kr.css";
</style>



// WEBPACK FOOTER //
// src/views/artistry/makeover/components/content.vue